<template>
    <header>
        <router-link to="/">
            <img src="/logo.svg" class="logo" />
        </router-link>

        <div class="menu">
            <ul>
                <li>Creations</li>
                <li>Tools</li>
                <li>Marketplace</li>
                <li>Forums</li>
            </ul>
        </div>

        <div v-if="oidcUser" class="user">
            Signed in as:&nbsp; <strong>{{ oidcUser.name }}</strong>
            <button @click="signOutOidc">Sign out</button>
        </div>
    </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters(['oidcUser']),
    },
    methods: {
        ...mapActions(['signOutOidc']),
    },
};
</script>

<style lang="scss" scoped>
header {
    background-color: rgb(4, 24, 90);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
}

.logo {
    display: block;
    width: 225px;
    border: 1px solid white;
    border-left-style: none;
    border-top-style: none;
    border-right: 2px solid gray;
    border-bottom-style: none;
    padding-right: 10px;
}

.user {
    display: flex;
    align-items: center;
    color: white;
    button {
        margin-left: 1rem;
    }
}

.menu {
    color: white;
    ul {
        position: relative;
        right: 170px;
        width: 100%;

        li {
            margin: 20px;
            text-shadow: 2px 2px 8px rgb(94, 91, 91);
        }

        li:hover {
            border-bottom: 2px solid white;
        }
    }
}

ul {
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
}
</style>
